module.exports = __webpack_public_path__ + "media/images/common/inside_black-0c58e358d8c9c469bc300f31bdca5530.jpg";